import { render } from "./SepaMandat.vue?vue&type=template&id=84c1e046&scoped=true"
import script from "./SepaMandat.vue?vue&type=script&lang=js"
export * from "./SepaMandat.vue?vue&type=script&lang=js"

import "./SepaMandat.vue?vue&type=style&index=0&id=84c1e046&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c1e046"]])

export default __exports__